<div class="relative w-full h-full" #container>
  <div #mapContainer class="w-full h-full rounded-md border border-solid"></div>
  <div class="scroll-overlay" [class.visible]="showScrollOverlay">
    <span>Use Ctrl + Scroll to zoom</span>
  </div>
  <twaice-fe-system-overview-popover [system$]="selectedSystem$" [visible]="showPopover" />
</div>
